// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f27f8aac","239":"bcd0e3ac","732":"d46d634d"}[chunkId] + ".chunk.js";
};